// extracted by mini-css-extract-plugin
export default {"accordion":"accordion-module--accordion--11IA8"};